import type { OpinionPoll } from '@/modules/opinions/types';
import { RootStore } from '@/store';
import { makeAutoObservable } from 'mobx';

export class OpinionsStore {
  readonly rootStore: RootStore;

  public opinions: OpinionPoll[] = [];
  public opinionsVotedCount: number = 0;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setOpinions(opinions: OpinionPoll[]) {
    this.opinions = opinions;
  }

  increaseOpinionsVotedCount() {
    this.opinionsVotedCount += 1;
  }

  clearOpinionsVotedCount() {
    this.opinionsVotedCount = 0;
  }
}
